import { ref } from 'vue';

// Define the loader state with TypeScript
export const isLoading = ref<boolean>(false);

// Function to show loader
export function showLoader(): void {
  isLoading.value = true;
}

// Function to hide loader
export function hideLoader(): void {
  if (document.body.classList.contains('sidebar-show'))
    document.body.classList.remove('sidebar-show');
  isLoading.value = false;
}
